<!-- 消息通知组件 -->
<template>
    <div class="notifyContent">

        <!-- Badge 标记 -->
        <div class="notifyIcon" @click="toggleExpansion">
            
            <el-badge class="notify-badge"  :value =  "unreadTotal > 0 ? unreadTotal : null">
                <i class="el-icon-chat-dot-square"> </i>
            </el-badge>
        </div>


        <!-- 消息通知弹窗容器-->
        <div class="chat-container" v-if="show" >

            <!-- 消息弹窗容器 -->
            <div class="chat-wrap">
                
                <!-- 消息弹窗表头 -->
                <div class="chat-header">
      
                    <!-- 弹窗关闭方法 -->
                    <div class="system-operate">

                        <!-- 弹窗关闭样式 -->
                        <i class="el-icon-close"    @click="handleClose"></i>
                    </div>
                </div>

                <!-- 消息弹窗内容区 -->
                <div class="chat-content">

                    <!-- 消息弹窗-左侧列表 -->
                    <div class="chat-list" placement="left">

                        <!-- 列表菜单 -->
                        <div class="chat-list-menu">

                            <!-- 定义左侧列表菜单 -->
                            <el-menu default-active="1" >

                                <el-menu-item v-for="item in  notifyListData " :index="item.id" :key="item.id"  style="padding-left: 5px;" @click="handleSelect(item)">

                                    <div class="chat-item">

                                        <!-- 行数据图标 -->
                                        <div class="system-icon">
                                            <i :class="item.menuIcon" style="margin-right: 0px; color: #fff;"></i>
                                        </div>

                                        <!-- 行数据展示内容 -->
                                        <div class="item-right-content">

                                            <div class="chat-title">
                                                <div class="chat-name"> {{ item.chatName }}</div>
                                                <div class="chat-time"> {{ item.createdAt }} </div>
                                            </div>

                                            <!-- 如果最后一条信息的 发布人 和当前登录人的id一样,就说明是工程内部进行查看的,那就展示为 -->
                                            <!-- <div class="chat-text" v-if="item.lastMessage.publishId == currentId">{{ item.lastMessage.publishContent }}</div> -->
                                            <div class="chat-text" >{{ item.lastMessage.content }}</div>
                                        </div>

                                        <div class="unread" v-if="item.unreadCount >0">
                                            <span style="box-sizing: border-box;" >{{ item.unreadCount }}</span>
                                        </div>
                                    </div>
                                </el-menu-item>
                            </el-menu>
                        </div>
                    </div>

                    <!-- 自定义右侧列表数据 -->
                    <div class="chat-detail">
                        <div class="chat-detail-content">
                            <div class="chat-system">
                                <div class="chat-content-head">
                                    <h2>{{moduleName}}</h2>
                                </div>

                                <div class="system-content">
                                    <div class="tabbar-option">
                                        <div class="tabbar-read-span">
                                            <el-button  size="mini" round @click="selectButton()">全部</el-button>
                                            <el-button  size="mini" round @click="selectButton(1)">未读</el-button>
                                        </div>
                                    </div>

                                    <div class="system-message-list">
                                        <div class="list-content">

                                            <div v-for="item in notifyListSms" :key="item.id"
                                                class="system-message-item">

                                                <div v-if="item.remindFlag === 0" class="sys-haveread">NEW</div>

                                                <div class="system-title">
                                                    <span class="flow">
                                                        <i :class="item.linkIcon" style="color: #fff;"></i>
                                                    </span>

                                                    <h3> {{ item.remindName }}</h3>
                                                </div>

                                                <div class="content">
                                                    <!-- <h2 v-if="item.publishId == currentId"> {{ item.publishContent }}</h2> -->
                                                    <h2 > {{ item.content }}</h2>

                                                    <p> 提交时间: {{ item.sendTime }}</p>
                                                </div>

                                                <div class="system-operation-box">
                                                    <a class="message-type" @click.prevent="goToMyProject(item)">查看详情</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import {bus} from '../../../utils/bus'
import { mapState } from 'vuex';
import moment from 'moment'
export default {

    name: 'NotificationModule',
    data() {
        return {

            // 1.消息弹窗展示状态值
            show: false,

            // 2.消息通知左侧列表
            notifyListData: [],

            // 消息通知右侧内容列表
            notifyListSms: [],

            // 消息未读总数
            unreadTotal:0,

            // 被选中的菜单id
            selctedMenuId: '',

            // 判断鼠标是否在 弹窗内部
            isInside: false,

            isVisible: false,

            // 项目模块名称
            moduleName:'',


            currentId:''
        }
    },

    computed:{
        ...mapState(['userId']),

        ...mapState(['userRoleId']),

        notifications(){
            return this.$store.state.notifications;
        },

        receiveNotifications(){
            return this.$store.state.receiveNotifications;
        }
    },





    watch: {

        // 消息提醒监听
        notifications(newVal){
             console.log(newVal);

             // 0.查询消息列表
             this.selectNotifyList();

              // // 1.然后调用查询方法
             this.selectNotifySms();
        },

        receiveNotifications(newVal){

            console.log(newVal);
            // 0.调用左侧列表查询方法
                  // 假设这是一个异步操作（即使是同步的，我们也可以模拟异步
            setTimeout(() => {
               
                this.selectNotifyList();

                //  1.然后调用查询方法
                this.selectNotifySms();

            }, 200);
        }
    },

    created() {
        // 1.调用方法
        this.selectNotifyList();
    },

    methods: {

        // 1.点击图标,打开弹窗
        toggleExpansion() {

            this.show = true;

            // 调用方法查询消息列表
            this.selectNotifyList();
        },

        // 2.关闭弹窗
        handleClose() {
            this.show = false;
        },

        // 3.点击左侧的消息列表进行查询
        handleSelect(item) {

            this.moduleName = item.menuName

            this.selectNotifySms(item.id);
        },

        // 5.系统初始化时加载的数据信息
        selectNotifyList() {
            
            this.currentId = this.userId;
            // 使用axios发送POST请求
            this.$axios.post('/selectNotifyList', {userId:this.userId, roleId:this.userRoleId}).then(resp => {
                if (resp && resp.data.code === 200) {
                    
                    // 1.对取到的结果进行判空
                    if(Array.isArray(resp.data.data.chatListInfo) && resp.data.data.chatListInfo.length > 0){
                        // 1.对集合信息进行遍历
                        resp.data.data.chatListInfo.forEach(item => {
                            item.createdAt = moment(item.createdAt).format('YYYY-MM-DD');

                            item.id = item.id.toString();

                            if(Array.isArray(item.chatListSmsList) && item.chatListSmsList.length > 0){
                                item.chatListSmsList.forEach(item =>{
                                    item.createAt = moment(item.createdAt).format('YYYY-MM-DD');
                                    item.sendTime = moment(item.sendTime).format('YYYY-MM-DD HH:mm:ss');
                                })
                            }
            
                        })
                    }




                    // 消息主表数据
                    this.notifyListData = resp.data.data.chatListInfo;

                    // 默认展示第一条数据的集合信息
                    if(Array.isArray(resp.data.data.chatListInfo) && resp.data.data.chatListInfo.length > 0){
                        
                        this.notifyListSms = resp.data.data.chatListInfo[0].chatListSmsList;

                        // 默认展示第一条数据的名称
                        this.moduleName = resp.data.data.chatListInfo[0].chatName;
                    }else {
                        this.notifyListSms = [];
                        this.moduleName = ''
                    }

                    // 2.未读消息数
                    this.unreadTotal = resp.data.data.unreadTotal;
                }
            }).catch(error => {
                this.$message.error(error);
            });
        },


        // 查看详情时,更改它的状态值
        handUpdateStatus(item){
            console.log('打印一下状态信息',item);
            this.$axios.post('/updateSmsStatusInfoById', {remindFlag:1, id:item.id}).then(resp => {
                if(item.remindFlag === 0){
                    if (resp && resp.data.code === 200) {
                        this.$message({ type:'success', message:"已阅"});

                        // 先将将状态值进行累加
                        this.$store.dispatch('updateCounter');

                        this.$store.dispatch('addNotification', this.counterNum);

                        // 调用下查询消息列表的方法
                        this.selectNotifyList();
                    }
                }

            }).catch(error => {
                this.$message.error(error);
            });
        },

        // 根据左侧点击的数据,查询右侧列表数据信息
        selectNotifySms(key) {

            // 1.不需要在查询数据库，根据传入的id,去遍历查询 this.notifyListData
            const targerObj =  this.notifyListData.find(item => String(item.id) === key);

            if(targerObj){

                this.notifyListSms =   targerObj.chatListSmsList;

                // 对这个集合进行处理

                this.notifyListSms.forEach(item => {

                    item.sendTime = moment(item.sendTime).format('YYYY-MM-DD HH:mm:ss');

                })
            }
        },

        // 根据点击 全部、未读进行查询数据内容
        selectButton(value){
            // 调用查询方法
            const testobject = localStorage.getItem('activeMenu');
            const storedActiveMenu = JSON.parse(testobject);
            const menuId = storedActiveMenu.id;

            this.selectNotifySms(menuId, value);
        },

        // 详情页面跳转
        goToMyProject(item){


            // 1.我的项目   (已经解决)
            if(item.remindId === 1){
                // 匹配规则
                const regex = /(.*\/myproject)\/(\d+)(?:\/(\d+))?/;

                const matches = item.linkUrl.match(regex);

                if(matches){
                    const [fullPath, basePath, id] = matches;

                    console.log("匹配的主键ID",fullPath);

                    console.log("匹配的主键ID",basePath);

                    this.$router.push({
                        name: 'MyProject'
                    }).then(()=>{

                        // 页面切换完成后，延时发送事件
                        setTimeout(()=>{
                            bus.$emit('openInspectionDetail', id);
                        }, 700);

                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    }).catch(() => {
                        // 进入catch = 【当前已经在inspection页面，重复导航】
                        // 直接发送事件，不需要延时
                        bus.$emit('openInspectionDetail', id);
                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    });


                    // if(this.$route.path !== basePath){

                    //     this.$router.push({
                    //         name: 'MyProject', // 必须用路由name，不能用path
                    //         params:{
                    //             id: id,
                    //             type: item.reportType 
                    //         }
                    //     }).catch(() => {});
                    // }else {
                    //     this.$router.push({
                    //         name: 'MyProject', // 必须用路由name，不能用path
                    //         params:{
                    //             id: id,
                    //             type: item.reportType 
                    //         }
                    //     }).catch(() => {});
                    // }
                }
            }

            // 2.质量管理。 remindId 设置为 2	
            if(item.remindId === 2){

                // 匹配规则
                const regex = /(.*\/quality)\/(\d+)(?:\/(\d+))?/;

                const matches = item.linkUrl.match(regex);

                if(matches){
                    const [fullPath, basePath, id] = matches;

                    console.log("匹配的主键ID",fullPath);

                    console.log("匹配的主键ID",basePath);

                    this.$router.push({
                        name: 'QualityControl'
                    }).then(()=>{

                        // 页面切换完成后，延时发送事件
                        setTimeout(()=>{
                            bus.$emit('openInspectionDetail', {
                                id: id,
                                type: item.reportType
                            });
                        }, 700);

                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    }).catch(() => {
                        // 进入catch = 【当前已经在inspection页面，重复导航】
                        // 同页面重复导航，直接发送
                        bus.$emit('openInspectionDetail', {
                            id: id,
                            type: item.reportType
                        });

                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    });

                    // if(this.$route.path !== basePath){

                    //     this.$router.push({
                    //         name: 'QualityControl', // 必须用路由name，不能用path
                    //         params:{
                    //             id: id,
                    //             type: item.reportType 
                    //         }
                    //     }).catch(() => {});
                    // }
                }
            }

            // 3.安全管理。remindId 设置为 3
            if(item.remindId === 3){

                // 匹配规则
                const regex = /(.*\/security)\/(\d+)(?:\/(\d+))?/;

                const matches = item.linkUrl.match(regex);

                if(matches){
                    const [fullPath, basePath, id] = matches;

                     console.log("匹配的主键ID",fullPath);

                    console.log("匹配的主键ID",basePath);

                    this.$router.push({
                        name: 'SecurityControl'
                    }).then(()=>{

                        // 页面切换完成后，延时发送事件
                        setTimeout(()=>{
                            bus.$emit('openInspectionDetail', {
                                id: id,
                                type: item.reportType
                            });
                        }, 700);

                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    }).catch(() => {
                        // 进入catch = 【当前已经在inspection页面，重复导航】
                        // 同页面重复导航，直接发送
                        bus.$emit('openInspectionDetail', {
                            id: id,
                            type: item.reportType
                        });

                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    });


                    // if(this.$route.path !== basePath){

                    //     this.$router.push({
                    //         name: 'SecurityControl', // 必须用路由name，不能用path
                    //         params:{
                    //             id: id,
                    //             type: item.reportType 
                    //         }
                    //     }).catch(() => {});
                    // }
                }
            }

            // 4.周报管理。remindId 设置为 4。
            if(item.remindId === 4){
                // 匹配规则
                const regex = /(.*\/reportManager)\/(\d+)(?:\/(\d+))?/;

                const matches = item.linkUrl.match(regex);
                
                if(matches){
                    const [basePath, id] = matches;

                    console.log("匹配的主键ID",basePath);

                    this.$router.push({
                        name: 'reportManager'
                    }).then(()=>{

                        // 页面切换完成后，延时发送事件
                        setTimeout(()=>{
                            bus.$emit('openInspectionDetail', {
                                id: id,
                                type: item.reportType
                            });
                        }, 700);

                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    }).catch(() => {
                        // 进入catch = 【当前已经在inspection页面，重复导航】
                        // 同页面重复导航，直接发送
                        bus.$emit('openInspectionDetail', {
                            id: id,
                            type: item.reportType
                        });

                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    });


                    // if(this.$route.path !== basePath){

                    //     this.$router.push({
                    //         name: 'reportManager', // 必须用路由name，不能用path
                    //         params:{
                    //             id: id,
                    //             type: item.reportType 
                    //         }
                    //     }).catch(() => {});
                    // }
                }
            }

            // 5.市政管理。remindId 设置为 5
            if(item.remindId === 5){
                // 匹配规则
                const regex = /(.*\/municipalInfo)\/(\d+)(?:\/(\d+))?/;

                const matches = item.linkUrl.match(regex);
                
                if(matches){
                    const [basePath, id] = matches;

                    console.log("匹配的主键ID",basePath);

                    this.$router.push({
                        name: 'Municipal'
                    }).then(()=>{

                        // 页面切换完成后，延时发送事件
                        setTimeout(()=>{
                            bus.$emit('openInspectionDetail', {
                                id: id,
                                type: item.reportType
                            });
                        }, 700);

                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    }).catch(() => {
                        // 进入catch = 【当前已经在inspection页面，重复导航】
                        // 同页面重复导航，直接发送
                        bus.$emit('openInspectionDetail', {
                            id: id,
                            type: item.reportType
                        });

                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    });


                    // if(this.$route.path !== basePath){

                    //     this.$router.push({
                    //         name: 'Municipal', // 必须用路由name，不能用path
                    //         params:{
                    //             id: id,
                    //             type: item.reportType 
                    //         }
                    //     }).catch(() => {});
                    // }
                }
            }            

            // 6.质量巡检。remindId 设置为 6
            if(item.remindId === 6){
                // 匹配规则
                const regex = /(.*\/qualition)\/(\d+)(?:\/(\d+))?/;

                const matches = item.linkUrl.match(regex);

                if(matches){
                    const [fullPath, basePath, id] = matches;

                    console.log("匹配的主键ID",fullPath);

                    console.log("匹配的主键ID",basePath);

                    this.$router.push({
                        name: 'Qualitytion'
                    }).then(()=>{

                        // 页面切换完成后，延时发送事件
                        setTimeout(()=>{
                            bus.$emit('openInspectionDetail', {
                                id: id,
                                type: item.reportType
                            });
                        }, 700);

                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    }).catch(() => {
                        // 进入catch = 【当前已经在inspection页面，重复导航】
                        // 同页面重复导航，直接发送
                        bus.$emit('openInspectionDetail', {
                            id: id,
                            type: item.reportType
                        });

                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    });



                    // if(this.$route.path !== basePath){

                    //     this.$router.push({
                    //         name: 'Qualitytion', // 必须用路由name，不能用path
                    //         params:{
                    //             id: id,
                    //             type: item.reportType 
                    //         }
                    //     }).catch(() => {});
                    // }
                }
            }

            // 7.安全巡检。remindId 设置为 7。(--已经解决)
            if(item.remindId === 7){

                // 匹配规则
                const regex = /(.*\/inspection)\/(\d+)(?:\/(\d+))?/;

                const matches = item.linkUrl.match(regex);

                if(matches){
                    const [fullPath, basePath, id] = matches;

                    console.log("匹配的主键ID",fullPath);

                    console.log('基本的路径信息',basePath);

                    this.$router.push({
                        name: 'SafeInspection'
                    }).then(()=>{

                        // 页面切换完成后，延时发送事件
                        setTimeout(()=>{
                            bus.$emit('openInspectionDetail', id);
                        }, 700);

                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    }).catch(() => {
                        // 进入catch = 【当前已经在inspection页面，重复导航】
                        // 直接发送事件，不需要延时
                        bus.$emit('openInspectionDetail', id);
                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    });
                }
            }

            // 8.总监巡检。remindId 设置为 8  
            if(item.remindId === 8){
                // 匹配规则
                const regex = /(.*\/director)\/(\d+)(?:\/(\d+))?/;

                const matches = item.linkUrl.match(regex);

                if(matches){
                    const [fullPath, basePath, id] = matches;

                    console.log("匹配的主键ID",fullPath);

                    console.log("匹配的主键ID",basePath);

                    this.$router.push({
                        name: 'DirectorCheck'
                    }).then(()=>{

                        // 页面切换完成后，延时发送事件
                        setTimeout(()=>{
                            bus.$emit('openInspectionDetail', {
                                id: id,
                                type: item.reportType
                            });
                        }, 700);

                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    }).catch(() => {
                        // 进入catch = 【当前已经在inspection页面，重复导航】
                        // 同页面重复导航，直接发送
                        bus.$emit('openInspectionDetail', {
                            id: id,
                            type: item.reportType
                        });

                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    });


                    // if(this.$route.path !== basePath){

                    //     this.$router.push({
                    //         name: 'DirectorCheck', // 必须用路由name，不能用path
                    //         params:{
                    //             id: id,
                    //             type: item.reportType 
                    //         }
                    //     }).catch(() => {});
                    // }
                }
            }

            // 9.内部会议安排。remindId 设置为 9  
            if(item.remindId === 9){
                // 匹配规则
                const regex = /(.*\/internalMeeting)\/(\d+)(?:\/(\d+))?/;

                const matches = item.linkUrl.match(regex);

                if(matches){
                    const [fullPath, basePath, id] = matches;


                    console.log("匹配的主键ID",fullPath);

                    console.log("匹配的主键ID",basePath);

                    this.$router.push({
                        name: 'InternalMeeting'
                    }).then(()=>{

                        // 页面切换完成后，延时发送事件
                        setTimeout(()=>{
                            bus.$emit('openInspectionDetail', {
                                id: id,
                                type: item.reportType
                            });
                        }, 700);

                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    }).catch(() => {
                        // 进入catch = 【当前已经在inspection页面，重复导航】
                        // 同页面重复导航，直接发送
                        bus.$emit('openInspectionDetail', {
                            id: id,
                            type: item.reportType
                        });

                        // 路由跳转成功后再关闭弹窗、更新状态
                        this.handleClose();
                        this.handUpdateStatus(item);
                    });


                    // if(this.$route.path !== basePath){

                    //     this.$router.push({
                    //         name: 'InternalMeeting', // 必须用路由name，不能用path
                    //         params:{
                    //             id: id,
                    //             type: item.reportType 
                    //         }
                    //     }).catch(() => {});
                    // }
                }
            }
        }
    }
}
</script>

<style scoped>

/** 1.消息通知样式图标 */
.notifyIcon {
    position: absolute;
    background-color: #4662b2;
    bottom: 20px;
    right: 35px;
    height: 40px;
    width: 40px;
    text-align: center;
    line-height: 40px;
    border-radius: 50%;
    color: #fff;
    font-size: 1.125rem;
    cursor: pointer;
    z-index: 1049;
}

.notifyIcon .notify-badge {
    z-index: 1050;
}

.notifyIcon .el-icon-chat-dot-square {
    font-size: 1.625rem;
    text-align: center;
    line-height: 40px;
    color: #fff;
}



/** 2.消息弹窗整体样式*/
.chat-container {
    position: fixed;
    right: 50px;
    bottom: 50px;
    width: 820px;
    height: 650px;
    z-index: 1024;
    max-height: calc(100% - 50px);
    min-height: 500px;
    box-sizing: border-box;
}

.chat-container .chat-wrap {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdcdc;
    background: #ffffff;
    border-radius: 5px;
    z-index: 1049;
    overflow: hidden;
    box-sizing: border-box;
}

/** 4.消息弹窗导航栏区域 */
.chat-container .chat-header {
    height: 54px;
    background: #FAFBFC;
    display: flex;
    width: 100%;
    justify-content: space-between;
    border-bottom: 1px solid #EFEFEF;
    box-sizing: border-box;
}

/** 8.消息主内容区域 */
.chat-container .chat-content {
    height: calc(100% - 54px);
    width: 100%;
    background-color: #f8f8f9;
    display: flex;
    box-sizing: border-box;
}

/** 9.主内容区域左侧菜单列表 */
.chat-list {
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #333;
    text-align: left;
    margin: 0;   
    box-sizing: border-box;
}

.chat-list .chat-item {
    padding: 0 10px;
    height: 58px;
    width: 100%;
    cursor: pointer;
    overflow: hidden;
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.chat-list .chat-item .system-icon {
    background: linear-gradient(32deg,rgb(219,129,87) 11.68%, rgb(230,167,92) 96.17%);
    width: 30px;
    height: 30px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    margin-right: 10px;
}


/* .chat-list .chat-item .system-icon i.el-icon-office-building {
    color: #fff;
} */


.chat-list .chat-item .item-right-content {
    height: 50px;
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: space-between;
    padding: 5px 0;
    overflow: hidden;
    box-sizing: border-box;
}

.chat-list .chat-item .item-right-content .chat-title {
    display: flex;
    justify-content: space-between;
    height: 18px;
    align-items: flex-start;
    box-sizing: border-box;
}

.chat-list .chat-item .item-right-content .chat-title .chat-name {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #333;
    max-width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    box-sizing: border-box;
}

.chat-list .chat-item .item-right-content .chat-title .chat-time {
    font-weight: 400;
    font-size: 12px;
    line-height: 18px;
    color: #999;
    white-space: nowrap;
    box-sizing: border-box;
}
 
.chat-list .chat-item .item-right-content .chat-text {
    font-weight: 400;
    font-size: 12px;
    height: 18px;
    line-height: 18px;
    max-width: calc(100% - 25px);
    text-overflow: ellipsis;
    overflow: hidden; 
    white-space: nowrap;
    color: #999;
    position: relative;
}

.chat-list .chat-item .unread {
    position: absolute;
    right: 8px;
    bottom: 6px;
    min-width: 22px;
    line-height: 20px;
    height: 22px;
    border-radius: 11px;
    background: #F04134;
    border: 1px solid #FFFFFF;
    text-align: center;
    color: #FFF;
    font-size: 12px;
    padding: 0 3px;
    transform: scale(0.75);
    box-sizing: border-box;
}




.chat-list-menu {
    position: relative;
    width: 240px;
    height: 100%;
    background-color: #ffffff;
    border-right: 1px solid #EFEFEF;
    box-sizing: border-box;
}

.chat-container .chat-content .chat-detail {
    height: 100%;
    overflow: hidden;
    flex: 1;
    box-sizing: border-box;
}

.chat-detail-content {
    height: 100%;
    width: 100%;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #333;
    text-align: left;
}

.chat-system {
    height: 100%;
    width: 100%;
    display: flex;
    flex-direction: column;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #333;
    text-align: left;
    box-sizing: border-box;
}

.chat-content-head {
    height: 50px;
    position: relative;
    box-sizing: border-box;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #333;
    text-align: left;
}

.chat-content-head h2 {
    color: #333;
    font-size: 1.125rem;
    height: 50px;
    margin: 0;
    font-weight: 700;
    padding-left: 16px;
    display: flex;
    align-items: center;
    line-height: 50px;
}

.chat-system .tabbar-option {
    display: flex;
    height: 36px;
    justify-content: space-between;
    align-items: center;
    padding:  0 17px;
    box-sizing: border-box;
    margin-bottom: 0.5rem;
}

.tabbar-read-span .tabbar-read-all {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 2px;
    cursor: pointer;
    background-color: rgba(70, 98, 178, 0.1);
    color: #4662b2;
    margin-right: 8px;
}

.tabbar-read-span .tabbar-read-unread {
    display: inline-block;
    color: #666;
    padding: 2px 8px;
    border-radius: 2px;
    cursor: pointer;
}

.chat-system .system-message-list {
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    height: calc(100% - 36px);
    margin: 0;
    position: relative;
}

.chat-system .system-message-list .list-content {
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: #fff0 !important;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #333;
    text-align: left;
}

.chat-system .system-message-list .system-message-item {
    position: relative;
    width: 513px;
    min-height: 172px;
    background: #FFFFFF;
    border-radius: 4px;
    box-shadow: 0 0 4px #0f154b29;
    margin: 0 auto;
    margin-bottom: 10px;
    padding: 15px;
    overflow: hidden;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #333;
    text-align: left;
}

.chat-system .system-message-list .system-message-item .system-title {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    position: relative;
    z-index: 2;
    max-width: 80%;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #333;
    text-align: left;
}

.chat-system .system-message-list .system-message-item .system-title .flow {
    width: 22px;
    height: 22px;
    line-height: 22px;
    border-radius: 3px;
    display: inline-block;
    text-align: center;
    background: linear-gradient(47.49deg, rgb(219, 129, 87) 11.68%, rgb(230, 167, 92) 96.17%);
}

.chat-system .system-message-list .system-message-item .system-title h3 {
    font-size: 0.875rem;
    color: #333;
    display: inline-block;
    margin-bottom: 0;
    line-height: 22px;
    padding-left: 10px;
    font-weight: 600;
    flex: 1;
    margin-top: 0;
    box-sizing: border-box;
}

.chat-system .system-message-list .system-message-item .content {
    border-radius: 3px;
    position: relative;
    z-index: 2;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #333;
    text-align: left;

}

.chat-system .system-message-list .system-message-item .content h2 {

    font-size: 0.875rem;
    color: #333 !important;
    line-height: 24px;
    padding-bottom: 7px;
    margin: 0;
    word-break: normal;
    font-family: inherit;
    font-weight: 500;
    box-sizing: border-box;
}

.chat-system .system-message-list .system-message-item .content p {
    font-size: 0.75rem;
    color: #999;
    margin: 0;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
    box-sizing: border-box;
}

.chat-system .system-message-list .system-message-item .system-operation-box {
    position: absolute;
    right: 15px;
    bottom: 15px;
    font-size: 0.875rem;
    z-index: 99;
}

.chat-system .system-message-list .system-message-item .system-operation-box a {
    cursor: pointer;
    display: inline-block;
    margin-left: 10px;
    color: #4e89f8;
    font-weight: 400;
    line-height: 1.5;
    text-align: left;
}

.chat-system .system-message-list .system-message-item .sys-haveread {
    position: absolute;
    right: -30px;
    top: 5px;
    width: 120px;
    height: 24px;
    background: rgba(245, 63, 63, 0.1);
    transform: rotate(27.85deg);
    color: #f53f3f;
    font-weight: 500;
    font-size: 13px;
    line-height: 24px;
    text-align: center;
    cursor: default;
    z-index: 1;
    box-sizing: border-box;
}

.chat-system .system-content {
    flex: 1;
    height: calc(100% - 50px);
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: #333;
    text-align: left;
    box-sizing: border-box;
}

.search-and-new {
    display: flex;
    flex: 1 1 40%;
    align-items: center;
    justify-content: flex-start;
}

.system-operate {
    display: flex;
    flex: 1 1 40%;
    justify-content: flex-end;
    color: #999;
    align-items: center;
}

.el-icon-close {
    font-size: 1.4rem;
    margin-right: 14px;
    cursor: pointer;
}
</style>